/**
 * @generated SignedSource<<c3042f33478750678d47a8dd9e8a2a74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GlobalNavbarFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RightContentFragment">;
  readonly " $fragmentType": "GlobalNavbarFragment";
};
export type GlobalNavbarFragment$key = {
  readonly " $data"?: GlobalNavbarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"GlobalNavbarFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GlobalNavbarFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RightContentFragment"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "c5201009e4bf7f2d53d14f06bf064fa3";

export default node;
